import { Routes } from '@angular/router';
import { HomePageComponent } from './specific/pages/home-page/home-page.component';
import { PageNotFoundComponent } from './specific/pages/page-not-found/page-not-found.component';
import { SignInPageComponent } from './specific/pages/sign-in-page/sign-in-page.component';
import { SelectLocationPageComponent } from './specific/pages/select-location-page/select-location-page.component';
import { OrderPageComponent } from './specific/pages/order-page/order-page.component';
import { OrderHistoryPageComponent } from './specific/pages/order-history-page/order-history-page.component';
import { MenuAvailabilityPageComponent } from './specific/pages/menu-availability-page/menu-availability-page.component';
import { SalesSummaryPageComponent } from './specific/pages/sales-summary-page/sales-summary-page.component';
import { OrdersForLaterPageComponent } from './specific/pages/orders-for-later-page/orders-for-later-page.component';

// https://angular.io/guide/router
// https://angular.io/start/start-routing

const routeConfig: Routes = [
  {
    path: '',
    component: HomePageComponent,
    title: 'Home page'
  },
  {
    path: 'signin',
    component: SignInPageComponent,
    title: 'Sign-in'
  },
  {
    path: 'select_location',
    component: SelectLocationPageComponent,
    title: 'Select Location'
  },
  {
    path: 'order/:orderId/from_page/:fromPage',
    component: OrderPageComponent,
    title: 'Order'
  },
  {
    // This entry is required so the page is properly loaded if from_page path parameter is not provided.
    path: 'order/:orderId',
    component: OrderPageComponent,
    title: 'Order'
  },
  {
    path: 'order_history',
    component: OrderHistoryPageComponent,
    title: 'Order History'
  },
  {
    path: 'orders_for_later',
    component: OrdersForLaterPageComponent,
    title: 'Orders for Later'
  },
  {
    path: 'menu_availability',
    component: MenuAvailabilityPageComponent,
    title: 'Menu Availability'
  },
  {
    path: 'sales_summary',
    component: SalesSummaryPageComponent,
    title: 'Sales Summary'
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    title: 'Page not found'
  },
];

export default routeConfig;
